import CryptoJS from 'crypto-js';

let cachedPermissions = null;

export const loadPermissions = () => {
    const userStr = localStorage.getItem(process.env.REACT_APP_LS_USER);
    if (userStr) {
        try {
            const user = JSON.parse(userStr);
            cachedPermissions = user?.permissions || [];
        } catch (e) {
            cachedPermissions = [];
        }
    } else {
        cachedPermissions = [];
    }
};

export const clearPermissionsCache = () => {
    cachedPermissions = null;
};

export const getBmsCredentials = () => {
    const credentials = { appCode: '', accId: '' };
    try {
        const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_LS_USER));
        if (!Array.isArray(user?.permissions)) return credentials;
        for (const encoded of user.permissions) {
            try {
                const permission = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(encoded));
                if (permission.startsWith('BMS_APPCODE|')) credentials.appCode = permission.slice('BMS_APPCODE|'.length);
                if (permission.startsWith('BMS_ACCID|')) credentials.accId = permission.slice('BMS_ACCID|'.length);
            } catch {
                // Ignore malformed permission entries.
            }
        }
    } catch {
        // User information is unavailable before login.
    }
    return credentials;
};

export const checkPermission = (permission) => {
    if (!cachedPermissions) loadPermissions();
    const encodedVal = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(permission));
    return cachedPermissions.includes(encodedVal);
};

export const checkPermissions = (permissions) => {
    if (!cachedPermissions) loadPermissions();
    if (!cachedPermissions || cachedPermissions.length === 0) return false;

    return permissions.some(permission => {
        const encodedVal = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(permission));
        return cachedPermissions.includes(encodedVal);
    });
};
